
    var riot = require('riot')
    
riot.tag2('career_details', '<raw content="{opts.opts.career_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.careers}" class="{active:parent.career_id == i}"><a href="./career_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addWorkExperience}" class="btn btn-success">Add Work Experience</a></li> <li> <confirm onconfirm="{deleteWorkExperience}"><a class="btn btn-danger">Delete Work Experience</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: career}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <forminput label="Start Date*" name="jobs_date_start" value="{career.jobs_date_start}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_date_start)}" isrequired></forminput> <forminput label="End Date" name="jobs_date_end" value="{career.jobs_date_end}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_date_end)}"></forminput> <forminput label="Occupation or Position Held" name="jobs_position" value="{career.jobs_position}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_position)}"></forminput> <formtextarea label="Main Activities and Responsibilities" name="jobs_activities" value="{career.jobs_activities}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_activities)}"></formtextarea> <forminput label="Name of Employer" name="jobs_organisation" value="{career.jobs_organisation}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_organisation)}"></forminput> <forminput label="Type of Business" name="jobs_orgtype" value="{career.jobs_orgtype}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_orgtype)}"></forminput> <forminput label="Address of Employer" name="jobs_orgaddress1" value="{career.jobs_orgaddress1}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_orgaddress1)}"></forminput> <forminput label=" " name="jobs_orgaddress2" value="{career.jobs_orgaddress2}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="jobs_orgaddress3" value="{career.jobs_orgaddress3}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="jobs_orgaddress4" value="{career.jobs_orgaddress4}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="jobs_orgaddress5" value="{career.jobs_orgaddress5}" onupdate="{handleUpdate}"></forminput> <forminput label="Zip/Post Code" name="jobs_orgpostcode" value="{career.jobs_orgpostcode}" onupdate="{handleUpdate}"></forminput> <forminput label="Country" name="jobs_orgcountry" value="{career.jobs_orgcountry}" onupdate="{handleUpdate}"></forminput> <forminput label="Telephone" name="jobs_orgtelephone" value="{career.jobs_orgtelephone}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_orgtelephone)}"></forminput> <forminput label="Website" name="jobs_website" value="{career.jobs_website}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.career.jobs_website)}"></forminput> </form> </div> </div> </div>', '', '', function(opts) {
this.careers = [];

this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.on('update', function() {
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    return this.load();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.careerErrors = opts.errors.filter(function(e) {
      return e.tab === 'careers';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.careerErrors.forEach(function(field) {
      return _this.tags[field].tags['formgroup'].trigger('validate');
    });
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.career[val.name] = val.value;
    return opts.onupdate('careers', _this.career_id, _this.career);
  };
})(this);

this.load = function() {
  var ref;
  this.careers = opts.psedata.careers;
  this.career_id = opts.params.career_id != null ? opts.params.career_id - 1 : 0;
  if (((ref = this.careers) != null ? ref[this.career_id] : void 0) != null) {
    this.career = this.careers[this.career_id];
  }
  return this.update();
};

this.addWorkExperience = function() {
  this.careers.push({});
  opts.page.redirect('career_details/' + this.careers.length);
  return this.update();
};

this.deleteWorkExperience = (function(_this) {
  return function() {
    _this.careers.splice(_this.career_id, 1);
    opts.page.redirect('career_details/' + _this.careers.length);
    return _this.update();
  };
})(this);
});
    
  